"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _theme = _interopRequireDefault(require("../../theme"));

var _modal = _interopRequireDefault(require("../style/modal"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Component = _interopRequireDefault(require("../../Component"));

var _insertCSSRule = _interopRequireDefault(require("../../../utils/insertCSSRule"));

var NO_SCROLL_CLASS_NAME = 'p24_web_components_modal_no_scroll',
    FX_CLASS_NAME = 'p24_web_components_modal_fx';
var instanceCount = 0;
var cssRulesWasAdded = false;

var Main =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Main, _React$Component);

  function Main(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Main);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Main).call(this, props));
    var root = props.root;
    _this.el = document.createElement('div');

    if (typeof root === 'string') {
      root = document.querySelector(root);
    }

    if (root instanceof HTMLElement) {
      _this.root = root;
    } else {
      _this.root = document.querySelector('body');
    }

    return _this;
  }

  (0, _createClass2["default"])(Main, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.root.appendChild(this.el);
      instanceCount += 1;

      if (instanceCount === 1) {
        this._rootFx('add');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.root.removeChild(this.el);
      instanceCount -= 1;

      if (instanceCount === 0) {
        this._rootFx('remove');
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _reactDom["default"].createPortal(this.props.children, this.el);
    }
  }, {
    key: "_rootFx",
    value: function _rootFx() {
      var _this2 = this;

      var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'add';

      var styles = _Component["default"].prototype.compileStyled.call(this, _modal["default"]),
          fx = this.props.fx;

      if (!cssRulesWasAdded) {
        (0, _insertCSSRule["default"])(NO_SCROLL_CLASS_NAME, styles.noScroll);
        (0, _insertCSSRule["default"])(FX_CLASS_NAME, styles.fx);
        cssRulesWasAdded = true;
      }

      if (this.root && fx) {
        var _this$root$childNodes;

        this.root.classList[method](NO_SCROLL_CLASS_NAME); // сделано именно так, потому что IE11 не поддерживает методы NodeList

        var processor = function processor(node) {
          if (node !== _this2.el && node instanceof HTMLElement && node.nodeName.toLowerCase() !== 'script') {
            node.classList[method](FX_CLASS_NAME);
          }
        };

        if (typeof ((_this$root$childNodes = this.root.childNodes) === null || _this$root$childNodes === void 0 ? void 0 : _this$root$childNodes.forEach) === 'function') {
          this.root.childNodes.forEach(processor);
        } else {
          [].slice.call(this.root.childNodes).forEach(processor);
        }
      }
    }
  }]);
  return Main;
}(_react["default"].Component);

(0, _defineProperty2["default"])(Main, "propTypes", {
  fx: _propTypes["default"].bool,
  root: _propTypes["default"].object,
  children: _propTypes["default"].any
});
(0, _defineProperty2["default"])(Main, "defaultProps", {
  fx: true
});
(0, _defineProperty2["default"])(Main, "displayName", 'Modal');

var _default = (0, _theme["default"])(Main, 'modal');

exports["default"] = _default;